import { useState } from "react";

import {
  Box,
  HStack,
  Heading,
  Image,
  Img,
  Text,
  VStack,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  ModalCloseButton,
  ModalHeader,
} from "@chakra-ui/react";

export function Introduction() {
  return (
    <VStack>
      <Box bgColor="peach.100" p={4} pr={8}>
        <HStack alignItems={"start"} gap={4}>
          <Img src="/RinconSeal.png" w="120px" mt={2} />
          <Box maxWidth="600px">
            <Heading size="md" textAlign={"center"}>
              Rincon Water Resources Dashboard
            </Heading>

            <br />
            <Text color="red" textAlign={"center"}>
              ** Data presented in this dashboard is confidential **
            </Text>
            <br />
            <Text textAlign={"justify"}>
              The Rincon Water Resources Dashboard permits the viewing of water-related data on the Rincon Reservation.
              It provides the ability to make simple comparisons in the condition of Rincon ground and surface water
              resources - such as viewing changes in a single water quality constituent at a single location over time,
              and the comparing of a single water quality constituent values at the same time, at different locations.
              Results can be displayed both in a tabular format and as a graph.
            </Text>
            <br />
            <Text textAlign={"justify"}>
              Near the top of each page, the user will select 1) a date range and 2) one or more sites, and then data
              will automatically be populated in the graph to show data over time. Data means (or averages) of each
              selected site are also shown on a map; the user will hover over each point on the map to see the minimum,
              maximum, and mean of the data selected for that time range. Additional statistics (minimum, maximum, and
              mean) for each selected site for the selected date range are shown in a table.
            </Text>

            <Image src={"OverviewMap_StreamsAndRivers.jpg"} alt="Rincon Logo" />

            <Instructions />
          </Box>
        </HStack>
      </Box>
    </VStack>
  );
}

function Instructions() {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");

  const openModal = (src: string) => {
    setSelectedImage(src);
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
    setSelectedImage("");
  };

  return (
    <VStack mt={4} alignItems={"stretch"}>
      <Heading size="md" textAlign={"center"}>
        Instructions
      </Heading>

      <Text>(click on the images to enlarge)</Text>

      <Heading size="sm">Dashboard</Heading>

      <Text>
        To use the Dashboard, first click on the project of your choice on the top bar. You will be presented with a
        form used to filter the data that will populate the graphs.
      </Text>

      <EnlargeableImage src="instructions/projects.png" onClick={openModal} />

      <Text>Input the desired start and end dates, then select one or more sites using the dropdown.</Text>

      <EnlargeableImage src="instructions/dropdown.png" onClick={openModal} />

      <Text>For the Surface, Ground, and Drinking Water projects, you will also need to select an analyte.</Text>

      <EnlargeableImage src="instructions/analyte.png" onClick={openModal} />

      <Text>
        After filling out the form, the Dashboard will automatically show you graphs with the data you requested.
      </Text>

      <EnlargeableImage src="instructions/graphs.png" onClick={openModal} />

      <Heading size="sm" mt={4}>
        Changing Site Colors
      </Heading>

      <Text>
        In the Dashboard, each site is represented by a specific color. You can modify these colors by clicking "Site
        Colors" on the top bar. You will be presented with a table of the colors assigned to each site. Click on a color
        to change it.
      </Text>

      <EnlargeableImage src="instructions/siteColors.png" onClick={openModal} />

      <Modal isOpen={isOpen} onClose={closeModal} size="6xl">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader />
          <ModalCloseButton />
          <ModalBody>
            <Image src={selectedImage} alt="Selected instruction" />
          </ModalBody>
        </ModalContent>
      </Modal>
    </VStack>
  );
}

const EnlargeableImage = ({ src, onClick }: { src: string; onClick: (src: string) => void }) => {
  return <Image src={src} cursor="zoom-in" onClick={() => onClick(src)} />;
};
